import MapStore from '../_flux/stores/map_store';
import StationsActions from '../_flux/actions/fitting_station_actions';
import {CUSTOM_LAT_LNG_CONSTRUCTOR_NAME} from '../_constants/map';
class Map {
	constructor($map) {
		this.$map = $map;
		this.currentZoomLevel = 11;
	}

	init(callback) {

		if (!this.loadDependencies()) {
			throw new Error('Google maps is has not loaded.');
		}

		//This will initialise default location behaviour and then initMap
		if (!this.location) {
			return this.initLocation(callback);
		}

		//We can init the map immediately
		this.initMap(callback);
	}

	loadDependencies() {

		if (!window.google.maps) {
			return false;
		}

		this.googleMaps = window.google.maps;
		this.geocoder = new this.googleMaps.Geocoder();

		return true;
	}

	initMap(callback) {

		// Set new styling
		this.googleMaps.visualRefresh = true;

		// add the google map
		var map = new this.googleMaps.Map(this.$map.get(0), this.getMapOptions());

		window.map = this.map = map;

		// the infoWindow for map overlay
		this.infoWindow = new this.googleMaps.InfoWindow();

		this.googleMaps.event.trigger(map, 'load');

		this.googleMaps.event.addListenerOnce(map, 'idle', this.resize.bind(this));
		this.googleMaps.event.addListenerOnce(map, 'idle', callback);

		return true;
	}

	resize() {
		this.googleMaps.event.trigger(this.map, 'resize');
		this.panToLocation(this.location);
	}

	/**
	 * @param  {google.maps.LatLng} location
	 */
	setLocation(location) {
		this.location = location;
	}

	setDefaultCoordinates(latLong) {
		this.defaultCoordinates = latLong;
	}

	/**
	 * @param  {google.maps.LatLng} location
	 */
	setLatLong(lat, long) {

		this.setLocation(this.formatLocation(lat, long));
	}

	/**
	 * @return {Object}
	 */
	getMapOptions() {

		return  {
			zoom                  : 11,
			center                : this.location,
			mapTypeId             : this.googleMaps.MapTypeId.ROADMAP,
			disableDefaultUI      : true,
			zoomControl           : true,
            mapId: '5a9df3e4416ef8c5',
			mapTypeControlOptions : {
				style   : this.googleMaps.MapTypeControlStyle.VERTICAL_BAR
			}
		};
	}

	/**
	 * Get initial location through HTML5 Geocoding
	 * @return {[type]} [description]
	 */
	initLocation(callback) {

		/**
		 *@todo  CHECK HOW THIS SHOULD BEHAVE
		 * Possibly use locate user later
		 */
		this.setToDefaultLocaton(callback);

	}

	/**
	 * @return {[type]} [description]
	 */
	locateUser() {

		//Attempt to locate the user, falling back to the default
		if (window.navigator && navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				$.proxy(this.handleGeolocation, this),
				$.proxy(this.setToDefaultLocaton, this),
				{
					timeout: 5000
				}
			);
			return true;
		}

		return false;
	}

	/**
	 * [handleGeolocation description]
	 * @param  {[type]} latlng [description]
	 * @return {[type]}        [description]
	 */
	handleGeolocation(latlng) {

		var location = this.formatLocation(
			latlng.coords.latitude,
			latlng.coords.longitude
		);

		this.setLocation(location);

		this.initMap();
	}


	setToDefaultLocaton(callback) {

		this.setLocation(this.formatLocation(
			this.defaultCoordinates.latitude,
			this.defaultCoordinates.longitude
		));

		this.initMap(callback);
	}

	/**
	 * @param  {Number} lat
	 * @param  {Number} long [description]
	 * @return {google.maps.LatLng}      [description]
	 */
	formatLocation(lat, long) {

		return new this.googleMaps.LatLng(lat, long);
	}

	/**
	 * Choose boundary for map
	 * @param  {google.maps.LatLngBounds} bounds
	 * @return {Map}
	 */
	fitBounds(bounds) {
		this.map.fitBounds(bounds);
		return this;
	}

	/**
	 * @return  {google.maps.LatLngBounds}
	 */
	getBounds() {

		return new this.googleMaps.LatLngBounds();
	}

	/**
	 * @return  {Map}
	 */
	zoomIn() {

		this.map.setZoom(17);
		this.currentZoomLevel = 17;
		return this;
	}

	/**
	 * @return  {Map}
	 */
	setZoom(zoom) {

		this.map.setZoom(zoom);
		this.currentZoomLevel = zoom;
		return this;
	}

	/**
	 * @return  {Map}
	 */
	setOnLoadZoom() {
		this.resize();
		if (this.loadedListener) {
			this.googleMaps.event.removeListener(this.loadedListener);
		}
		return this;
	}

	/**
	 * @param  {google.maps.LatLng} location
	 * @return {Map}
	 */
	panToLocation(location) {
        this.map.panTo(this._recreateLatLng(location));
	}

    _recreateLatLng(latLng) {
        let lat, lng = 0;
        if (typeof latLng.lat === 'function') {
            lat = latLng.lat();
        } else if(typeof latLng.lat !== 'undefined') {
            lat = latLng.lat;
        }

        if (typeof latLng.lng === 'function') {
            lng = latLng.lng();
        } else if(typeof latLng.lng !== 'undefined') {
            lng = latLng.lng;
        }

        const newLocation = new this.googleMaps.LatLng(lat, lng);

        return newLocation;
    }

	/**
	 * Get Google map
	 * @return {maps.google.Map} [description]
	 */
	getGoogleMap() {

		return this.map;
	}

	/**
	 * [panToLocation description]
	 * @param  {google.maps.LatLng} latLng
	 * @return {Map}
	 */
	parseGoogleLatLng(latLng) {
		return {
			latitude : latLng.lat(),
			longitude : latLng.lng()
		};
	}

    /**
	 *
     * @param address
     * @returns {*}
     */
    checkForPostcodeFix(address) {
        var postcodesAU = {
            '836': [-12.530,131.100],
            '1001': [-33.790,151.270],
            '1002': [-33.790,151.270],
            '1004': [-33.790,151.270],
            '1005': [-33.790,151.270],
            '1006': [-33.790,151.270],
            '1007': [-33.790,151.270],
            '1008': [-33.790,151.270],
            '1009': [-33.790,151.270],
            '1010': [-33.790,151.270],
            '1020': [-33.790,151.270],
            '1021': [-33.790,151.270],
            '1022': [-33.790,151.270],
            '1023': [-33.790,151.270],
            '1025': [-33.790,151.270],
            '1026': [-33.790,151.270],
            '1027': [-33.790,151.270],
            '1029': [-33.790,151.270],
            '1030': [-33.790,151.270],
            '1031': [-33.790,151.270],
            '1032': [-33.660,150.870],
            '1033': [-33.790,151.270],
            '1034': [-33.790,151.270],
            '1036': [-33.790,151.270],
            '1037': [-33.790,151.270],
            '1038': [-33.790,151.270],
            '1039': [-33.790,151.270],
            '1040': [-33.790,151.270],
            '1041': [-33.790,151.270],
            '1042': [-33.790,151.270],
            '1043': [-33.790,151.270],
            '1044': [-33.790,151.270],
            '1045': [-33.790,151.270],
            '1046': [-33.790,151.270],
            '1101': [-33.790,151.270],
            '1105': [-33.790,151.270],
            '1106': [-33.790,151.270],
            '1107': [-33.790,151.270],
            '1109': [-33.790,151.270],
            '1110': [-33.790,151.270],
            '1112': [-33.790,151.270],
            '1113': [-33.790,151.270],
            '1114': [-33.790,151.270],
            '1115': [-33.790,151.270],
            '1116': [-33.670,150.870],
            '1117': [-33.660,150.870],
            '1118': [-33.790,151.270],
            '1119': [-33.790,151.270],
            '1120': [-33.790,151.270],
            '1121': [-33.790,151.270],
            '1122': [-33.790,151.270],
            '1123': [-33.790,151.270],
            '1124': [-33.790,151.270],
            '1126': [-33.790,151.270],
            '1127': [-33.790,151.270],
            '1128': [-33.790,151.270],
            '1129': [-33.790,151.270],
            '1130': [-33.790,151.270],
            '1131': [-33.790,151.270],
            '1132': [-33.660,150.870],
            '1133': [-33.790,151.270],
            '1134': [-33.790,151.270],
            '1135': [-33.790,151.270],
            '1137': [-33.790,151.270],
            '1139': [-33.790,151.270],
            '1140': [-33.790,151.270],
            '1141': [-33.790,151.270],
            '1142': [-33.790,151.270],
            '1143': [-33.790,151.270],
            '1144': [-33.790,151.270],
            '1145': [-33.790,151.270],
            '1146': [-33.790,151.270],
            '1147': [-33.790,151.270],
            '1148': [-33.790,151.270],
            '1149': [-33.790,151.270],
            '1150': [-33.790,151.270],
            '1151': [-33.790,151.270],
            '1152': [-33.790,151.270],
            '1153': [-33.790,151.270],
            '1154': [-33.790,151.270],
            '1155': [-33.790,151.270],
            '1156': [-33.790,151.270],
            '1157': [-33.790,151.270],
            '1158': [-33.790,151.270],
            '1159': [-33.790,151.270],
            '1161': [-33.790,151.270],
            '1162': [-33.790,151.270],
            '1163': [-33.790,151.270],
            '1164': [-33.790,151.270],
            '1165': [-33.790,151.270],
            '1166': [-33.790,151.270],
            '1167': [-33.790,151.270],
            '1168': [-33.790,151.270],
            '1169': [-33.790,151.270],
            '1170': [-33.790,151.270],
            '1171': [-33.790,151.270],
            '1172': [-33.790,151.270],
            '1173': [-33.790,151.270],
            '1174': [-33.790,151.270],
            '1175': [-33.790,151.270],
            '1176': [-33.790,151.270],
            '1178': [-33.790,151.270],
            '1179': [-33.790,151.270],
            '1180': [-33.790,151.270],
            '1182': [-33.790,151.270],
            '1183': [-33.790,151.270],
            '1184': [-33.790,151.270],
            '1185': [-33.790,151.270],
            '1186': [-33.790,151.270],
            '1187': [-33.790,151.270],
            '1188': [-33.790,151.270],
            '1189': [-33.790,151.270],
            '1190': [-33.790,151.270],
            '1191': [-33.790,151.270],
            '1192': [-34.790,147.690],
            '1193': [-33.790,151.270],
            '1194': [-33.790,151.270],
            '1195': [-33.790,151.270],
            '1196': [-33.790,151.270],
            '1197': [-33.790,151.270],
            '1198': [-33.790,151.270],
            '1199': [-33.790,151.270],
            '1200': [-33.790,151.270],
            '1201': [-33.790,151.270],
            '1202': [-33.790,151.270],
            '1203': [-33.790,151.270],
            '1204': [-33.790,151.270],
            '1205': [-33.790,151.270],
            '1206': [-33.790,151.270],
            '1207': [-33.790,151.270],
            '1208': [-29.820,151.660],
            '1209': [-33.890,151.180],
            '1210': [-33.890,151.180],
            '1211': [-33.890,151.180],
            '1212': [-33.890,151.180],
            '1213': [-33.890,151.180],
            '1214': [-33.890,151.180],
            '1215': [-33.890,151.180],
            '1216': [-33.740,151.030],
            '1217': [-33.740,151.030],
            '1218': [-33.740,151.030],
            '1219': [-33.740,151.030],
            '1220': [-33.740,151.030],
            '1221': [-33.870,151.210],
            '1222': [-33.870,151.210],
            '1223': [-33.870,151.210],
            '1224': [-33.870,151.210],
            '1225': [-33.870,151.210],
            '1226': [-33.870,151.210],
            '1227': [-33.870,151.210],
            '1228': [-33.870,151.210],
            '1229': [-33.870,151.210],
            '1230': [-33.870,151.210],
            '1231': [-33.820,151.040],
            '1232': [-33.820,151.040],
            '1233': [-33.820,151.040],
            '1234': [-33.820,151.040],
            '1235': [-33.820,151.040],
            '1236': [-29.820,151.660],
            '1237': [-29.820,151.660],
            '1238': [-29.820,151.660],
            '1239': [-29.820,151.660],
            '1240': [-29.820,151.660],
            '1291': [-33.790,151.270],
            '1292': [-33.790,151.270],
            '1293': [-33.790,151.270],
            '1294': [-33.790,151.270],
            '1295': [-33.790,151.270],
            '1296': [-33.790,151.270],
            '1297': [-33.790,151.270],
            '1298': [-33.790,151.270],
            '1299': [-33.790,151.270],
            '1335': [-33.820,151.120],
            '1340': [-35.540,148.020],
            '1355': [-33.890,151.260],
            '1360': [-33.880,151.240],
            '1401': [-33.880,151.200],
            '1420': [-33.730,150.930],
            '1422': [-33.730,150.930],
            '1423': [-33.730,150.930],
            '1424': [-33.730,150.930],
            '1425': [-33.730,150.930],
            '1428': [-33.730,150.930],
            '1429': [-33.730,150.930],
            '1430': [-33.890,151.200],
            '1435': [-33.710,151.110],
            '1440': [-33.900,151.060],
            '1441': [-33.900,151.060],
            '1445': [-34.080,151.010],
            '1460': [-33.930,151.210],
            '1465': [-33.890,151.140],
            '1466': [-33.910,151.230],
            '1470': [-33.840,151.150],
            '1475': [-33.910,151.150],
            '1480': [-33.940,151.100],
            '1490': [-34.040,151.110],
            '1493': [-33.980,151.090],
            '1495': [-34.050,151.120],
            '1499': [-34.020,151.060],
            '1515': [-33.820,151.210],
            '1570': [-33.810,151.190],
            '1582': [-33.830,151.200],
            '1585': [-33.830,151.200],
            '1590': [-33.290,151.470],
            '1595': [-33.790,151.190],
            '1597': [-33.790,151.190],
            '1630': [-33.710,151.100],
            '1639': [-33.790,151.250],
            '1658': [-33.700,151.220],
            '1660': [-33.700,151.220],
            '1675': [-33.830,151.140],
            '1680': [-33.760,151.140],
            '1685': [-33.800,151.090],
            '1712': [-33.780,151.120],
            '1715': [-33.760,151.050],
            '1730': [-33.760,150.970],
            '1740': [-33.890,151.140],
            '1741': [-33.890,151.140],
            '1755': [-33.770,150.970],
            '1765': [-33.740,151.030],
            '1771': [-33.760,151.050],
            '1790': [-33.860,151.200],
            '1800': [-34.100,150.780],
            '1805': [-33.890,151.100],
            '1811': [-33.820,151.050],
            '1816': [-33.880,151.090],
            '1819': [-33.880,151.090],
            '1830': [-33.860,150.950],
            '1835': [-33.880,151.020],
            '1848': [-33.850,150.970],
            '1860': [-33.850,150.960],
            '1871': [-33.890,151.100],
            '1875': [-33.950,150.920],
            '1885': [-33.910,151.020],
            '1888': [-33.910,151.020],
            '1890': [-33.960,150.800],
            '1891': [-33.930,151.000],
            '2000': [-33.860,151.210],
            '2001': [-33.790,151.270],
            '2002': [-35.970,146.410],
            '2006': [-33.890,151.190],
            '2007': [-33.880,151.200],
            '2008': [-33.890,151.200],
            '2009': [-33.870,151.190],
            '2010': [-33.880,151.220],
            '2011': [-33.870,151.230],
            '2012': [-33.730,150.930],
            '2013': [-33.730,150.930],
            '2015': [-33.900,151.200],
            '2016': [-33.890,151.200],
            '2017': [-33.900,151.210],
            '2018': [-33.930,151.210],
            '2019': [-33.960,151.210],
            '2020': [-33.929,151.194],
            '2021': [-33.890,151.220],
            '2022': [-33.890, 151.250],
            '2023': [-33.890,151.260],
            '2024': [-33.900, 151.260],
            '2025': [-33.890, 151.240],
            '2026': [-33.890, 151.260],
            '2027': [-33.870, 151.240],
            '2028': [-33.880, 151.240],
            '2029': [-33.870, 151.280],
            '2030': [-33.870, 151.280],
            '2034': [-33.920,151.250],
            '2036': [-33.980,151.240],
            '2042': [-33.900,151.170],
            '2050': [-33.890,151.180],
            '2055': [-33.800,151.100],
            '2057': [-33.790,151.190],
            '2071': [-33.750,151.170],
            '2079': [-33.660,151.120],
            '2081': [-33.576,151.169],
            '2123': [-33.890,151.140],
            '2124': [-33.890,151.140],
            '2309': [-30.350,148.890],
            '2314': [-32.800,151.840],
            '2331': [-32.690,151.180],
            '2351': [-30.490,151.640],
            '2505': [-34.490,150.890],
            '2520': [-33.940,151.140],
            '2608': [-35.280,149.130],
            '2616': [-35.250,149.070],
            '2751': [-33.730,151.280],
            '2755': [-33.600,150.800],
            '2899': [-36.080,146.930],
            '3001': [-38.370,144.770],
            '3164': [-38.020,145.240],
            '3251': [-38.190,143.640],
            '3292': [-38.050,141.010],
            '3309': [-37.790,141.500],
            '3310': [-37.720,141.550],
            '3353': [-37.780,144.840],
            '3354': [-37.560,143.870],
            '3402': [-37.160,142.670],
            '3447': [-37.130,144.360],
            '3502': [-37.970,145.260],
            '3567': [-35.890,144.240],
            '3619': [-37.660,144.940],
            '3632': [-36.540,145.600],
            '3640': [-35.970,145.460],
            '3643': [-35.960,145.630],
            '3661': [-38.200,146.540],
            '3671': [-36.390,145.420],
            '3676': [-36.340,146.340],
            '3677': [-36.350,146.300],
            '3687': [-36.010,146.400],
            '3689': [-37.680,144.990],
            '3694': [-36.140,146.920],
            '3700': [-36.180,147.340],
            '3724': [-37.050,146.080],
            '3736': [-36.460,146.480],
            '3853': [-38.100,146.060],
            '3990': [-38.450,145.530],
            '4001': [-27.600,152.820],
            '4003': [-24.870,152.350],
            '4004': [-24.050,149.320],
            '4400': [-27.500,151.800],
            '4423': [-27.250,149.680],
            '4711': [-23.250,150.480],
            '4750': [-21.040,149.160],
            '5001': [-35.120,139.270],
            '5005': [-34.920,138.600],
            '5008': [-34.900,138.560],
            '5071': [-34.920,138.620],
            '5246': [-34.930,138.680],
            '5471': [-33.470,138.480],
            '5480': [-33.050,138.430],
            '5490': [-33.180,138.480],
            '5520': [-33.830,138.120],
            '5800': [-35.120,139.270],
            '5839': [-35.120,139.270],
            '5942': [-34.860,138.570],
            '6001': [-31.990,115.760],
            '6231': [-33.360,115.660],
            '6332': [-32.050,115.970],
            '6433': [-31.880,115.920],
            '6531': [-32.280,115.740],
            '6711': [-21.460,115.000],
            '6731': [-16.090,123.610],
            '6733': [-16.130,123.740],
            '6798': [-10.490,105.640],
            '6800': [-31.990,115.760],
            '6809': [-31.990,115.760],
            '6820': [-31.990,115.760],
            '6827': [-31.990,115.760],
            '6830': [-31.990,115.760],
            '6831': [-31.960,115.860],
            '6832': [-31.960,115.870],
            '6837': [-31.990,115.760],
            '6838': [-31.990,115.760],
            '6839': [-31.990,115.760],
            '6840': [-31.990,115.760],
            '6841': [-31.990,115.760],
            '6842': [-31.990,115.760],
            '6843': [-31.990,115.760],
            '6844': [-31.990,115.760],
            '6845': [-31.990,115.760],
            '6846': [-31.990,115.760],
            '6847': [-31.990,115.760],
            '6848': [-31.990,115.760],
            '6850': [-33.660,115.330],
            '6872': [-31.940,115.880],
            '6892': [-31.780,115.820],
            '6901': [-31.940,115.880],
            '6904': [-31.940,115.830],
            '6906': [-31.980,115.760],
            '6910': [-31.980,115.770],
            '6911': [-32.400,115.760],
            '6912': [-32.010,115.760],
            '6914': [-31.860,115.820],
            '6915': [-31.950,115.850],
            '6916': [-31.890,115.800],
            '6917': [-31.890,115.800],
            '6920': [-31.860,115.780],
            '6921': [-31.880,115.790],
            '6922': [-31.900,115.800],
            '6924': [-32.560,115.800],
            '6926': [-31.940,116.010],
            '6929': [-31.950,115.850],
            '6932': [-31.920,115.880],
            '6933': [-31.910,115.900],
            '6935': [-31.920,115.920],
            '6937': [-31.900,115.850],
            '6938': [-31.900,115.850],
            '6940': [-31.900,115.850],
            '6941': [-31.840,115.860],
            '6943': [-31.890,115.890],
            '6944': [-31.860,115.900],
            '6946': [-31.620,115.720],
            '6951': [-32.070,115.820],
            '6952': [-31.890,115.820],
            '6956': [-31.990,115.850],
            '6959': [-32.070,115.990],
            '6963': [-32.080,115.790],
            '6964': [-32.020,115.860],
            '6966': [-32.140,115.860],
            '6968': [-32.110,115.780],
            '6979': [-31.950,115.900],
            '6981': [-31.950,115.880],
            '6982': [-31.870,116.170],
            '6984': [-31.970,115.930],
            '6985': [-33.630,115.600],
            '6988': [-32.050,115.960],
            '6989': [-32.040,116.010],
            '6990': [-32.060,116.010],
            '6992': [-31.960,115.920],
            '7001': [-42.840,147.510],
            '7002': [-42.900,147.450],
            '7006': [-42.910,147.340],
            '7051': [-42.990,147.330],
            '7800': [-41.500,147.170],
            '7802': [-41.500,147.170],
            '7803': [-41.500,147.170],
            '7804': [-41.500,147.170],
            '7805': [-41.500,147.170],
            '7806': [-41.500,147.170],
            '7807': [-41.500,147.170],
            '7808': [-41.500,147.170],
            '7809': [-41.500,147.170],
            '7810': [-41.500,147.170],
            '7811': [-41.500,147.170],
            '7812': [-41.500,147.170],
            '7813': [-41.500,147.170],
            '7814': [-41.500,147.170],
            '7823': [-41.500,147.170],
            '7824': [-41.500,147.170],
            '7827': [-41.500,147.170],
            '7828': [-41.500,147.170],
            '7829': [-41.500,147.170],
            '7845': [-41.500,147.170],
            '7850': [-41.500,147.170],
            '7901': [-41.350,148.140],
            '7902': [-41.350,148.140],
            '7903': [-41.350,148.140],
            '7904': [-41.350,148.140],
            '7905': [-41.350,148.140],
            '7906': [-41.350,148.140],
            '7907': [-41.350,148.140],
            '7908': [-41.350,148.140],
            '7909': [-41.350,148.140],
            '7910': [-41.350,148.140],
            '7911': [-41.350,148.140],
            '7912': [-41.350,148.140],
            '7913': [-41.350,148.140],
            '7914': [-41.350,148.140],
            '7922': [-41.350,148.140],
            '8005': [-37.820,144.950],
            '8006': [-37.810,144.960],
            '8009': [-37.820,144.960],
            '8011': [-37.810,144.960],
            '8045': [-38.370,144.770],
            '8051': [-38.370,144.770],
            '8060': [-38.370,144.770],
            '8061': [-38.370,144.770],
            '8069': [-38.370,144.770],
            '8070': [-38.370,144.770],
            '8071': [-38.370,144.770],
            '8102': [-38.370,144.770],
            '8103': [-38.370,144.770],
            '8107': [-38.370,144.770],
            '8108': [-38.370,144.770],
            '8111': [-38.370,144.770],
            '8120': [-38.370,144.770],
            '8205': [-38.370,144.770],
            '8383': [-38.370,144.770],
            '8386': [-38.370,144.770],
            '8388': [-38.370,144.770],
            '8390': [-38.370,144.770],
            '8393': [-38.370,144.770],
            '8396': [-38.370,144.770],
            '8576': [-37.760,145.040],
            '8627': [-37.840,145.060],
            '8873': [-37.850,144.890],
            '9000': [-27.600,152.820],
            '9001': [-27.600,152.820],
            '9002': [-27.600,152.820],
            '9005': [-27.600,152.820],
            '9007': [-27.600,152.820],
            '9008': [-27.600,152.820],
            '9009': [-27.600,152.820],
            '9010': [-27.600,152.820],
            '9013': [-27.600,152.820],
            '9015': [-27.600,152.820],
        };

        var postcodesNZ = {
            '0140': [-35.7245, 174.3213],
            '0141': [-35.6834, 174.3008],
            '0142': [-35.7546, 174.3681],
            '0143': [-35.7343, 174.3054],
            '0144': [-35.6866, 174.3266],
            '0145': [-35.7085, 174.3207],
            '0146': [-35.8451, 174.2048],
            '0147': [-35.7429, 174.308],
            '0148': [-35.7512, 174.3152],
            '0149': [-35.7247, 174.3259],
            '0150': [-35.5979, 174.2863],
            '0151': [-35.8751, 174.4554],
            '0152': [-35.7549, 174.2081],
            '0153': [-35.6129, 174.522],
            '0154': [-35.6297, 174.5041],
            '0241': [-35.3124, 174.1206],
            '0242': [-35.2628, 174.1228],
            '0243': [-35.3799, 174.0672],
            '0244': [-35.3875, 174.0144],
            '0245': [-35.2289, 173.9487],
            '0246': [-35.206, 173.9167],
            '0247': [-35.282, 174.0915],
            '0271': [-35.2851, 174.0397],
            '0340': [-35.9413, 173.8697],
            '0341': [-36.0309, 173.923],
            '0440': [-35.4081, 173.7986],
            '0441': [-35.114, 173.2637],
            '0442': [-34.9896, 173.5366],
            '0443': [-35.3932, 173.5056],
            '0444': [-35.5367, 173.3862],
            '0445': [-35.5046, 173.3924],
            '0446': [-35.556, 173.4759],
            '0447': [-35.3201, 173.7713],
            '0448': [-35.1006, 173.7805],
            '0449': [-35.171, 173.1534],
            '0451': [-35.048, 173.2565],
            '0453': [-35.3582, 173.5461],
            '0460': [-34.8149, 173.1178],
            '0462': [-35.2592, 173.3896],
            '0540': [-36.1258, 174.5746],
            '0541': [-36.0946, 174.5874],
            '0542': [-36.1642, 174.4428],
            '0543': [-36.103, 174.2315],
            '0545': [-35.9842, 174.4453],
            '0547': [-36.1102, 174.3537],
            '0549': [-36.1365, 174.0233],
            '0550': [-36.1298, 174.1825],
            '0640': [-36.9079, 174.6831],
            '0641': [-36.9118, 174.652],
            '0642': [-36.9378, 174.6575],
            '0643': [-36.9306, 174.6801],
            '0644': [-36.9234, 174.7015],
            '0645': [-36.8869, 174.6446],
            '0650': [-36.881, 174.6347],
            '0651': [-36.8422, 174.6515],
            '0652': [-36.865, 174.6463],
            '0653': [-36.8655, 174.58],
            '0654': [-36.8557, 174.6298],
            '0655': [-36.8639, 174.6011],
            '0656': [-36.8332, 174.6224],
            '0657': [-36.8222, 174.6105],
            '0660': [-36.8492, 174.5447],
            '0661': [-36.8107, 174.6446],
            '0662': [-36.7935, 174.6163],
            '0663': [-36.8185, 174.6292],
            '0740': [-36.7875, 174.7729],
            '0741': [-36.7728, 174.7661],
            '0742': [-36.6949, 174.7506],
            '0743': [-36.7512, 174.7467],
            '0744': [-36.8303, 174.7969],
            '0745': [-36.768, 174.7395],
            '0746': [-36.8123, 174.7254],
            '0747': [-36.782, 174.7216],
            '0748': [-36.8017, 174.7446],
            '0749': [-36.7925, 174.6872],
            '0750': [-36.7969, 174.7782],
            '0751': [-36.7513, 174.7139],
            '0752': [-36.7313, 174.7075],
            '0753': [-36.7155, 174.7484],
            '0754': [-36.7384, 174.7534],
            '0755': [-36.7246, 174.6952],
            '0756': [-36.7758, 174.6702],
            '0757': [-36.743, 174.7248],
            '0758': [-36.7397, 174.7419],
            '0800': [-36.6765, 174.4527],
            '0840': [-36.6764, 174.4505],
            '0841': [-36.7754, 174.5548],
            '0842': [-36.7687, 174.4926],
            '0843': [-36.6164, 174.4933],
            '0940': [-36.2938, 174.5238],
            '0941': [-36.3978, 174.6639],
            '0942': [-36.4204, 174.7235],
            '0943': [-36.6366, 174.748],
            '0944': [-36.6178, 174.6778],
            '0945': [-36.6056, 174.6978],
            '0946': [-36.5856, 174.6943],
            '0947': [-36.2905, 174.8047],
            '0948': [-36.3519, 174.7169],
            '0950': [-36.5447, 174.7058],
            '0951': [-36.5121, 174.661],
            '0960': [-36.1556, 175.3935],
            '0961': [-36.2427, 175.462],
            '0962': [-36.3015, 175.4883],
            '0963': [-36.1639, 175.3624],
            '1010': [-36.8052, 174.9811],
            '1140': [-36.8472, 174.7692],
            '1142': [-36.8478, 174.7577],
            '1143': [-36.8451, 174.7675],
            '1144': [-36.8481, 174.7437],
            '1145': [-36.8578, 174.7579],
            '1147': [-36.846, 174.7339],
            '1148': [-36.8609, 174.7695],
            '1149': [-36.8731, 174.7773],
            '1150': [-36.8641, 174.7621],
            '1151': [-36.8568, 174.7811],
            '1245': [-36.8654, 174.7378],
            '1246': [-36.8702, 174.7107],
            '1340': [-36.9004, 174.72],
            '1342': [-36.8885, 174.7472],
            '1344': [-36.8918, 174.7745],
            '1345': [-36.9117, 174.7763],
            '1346': [-36.8837, 174.733],
            '1347': [-36.9, 174.7734],
            '1348': [-36.8878, 174.6845],
            '1349': [-36.8823, 174.7619],
            '1350': [-36.8849, 174.715],
            '1351': [-36.893, 174.7363],
            '1352': [-36.8724, 174.744],
            '1440': [-36.9032, 174.742],
            '1443': [-36.9262, 174.7231],
            '1445': [-36.9202, 174.7367],
            '1446': [-36.8801, 174.7495],
            '1541': [-36.8804, 174.798],
            '1542': [-36.898, 174.8092],
            '1543': [-36.8823, 174.7849],
            '1544': [-36.8992, 174.8053],
            '1545': [-36.8961, 174.8324],
            '1546': [-36.895, 174.8001],
            '1640': [-36.9444, 174.8441],
            '1641': [-36.9079, 174.838],
            '1642': [-36.9097, 174.8145],
            '1643': [-36.9205, 174.7861],
            '1740': [-36.8507, 174.8577],
            '1741': [-36.9005, 174.8557],
            '1742': [-36.8758, 174.8277],
            '1743': [-36.8791, 174.8552],
            '1744': [-36.8493, 174.8288],
            '1745': [-36.856, 174.8147],
            '1746': [-36.8975, 174.6973],
            '1840': [-36.7834, 175.0105],
            '1841': [-36.792, 175.0798],
            '1842': [-36.7938, 175.026],
            '1843': [-36.796, 175.0465],
            '1971': [-36.7931, 175.0922],
            '2010': [-36.9104, 174.8925],
            '2012': [-36.8714, 174.8978],
            '2013': [-36.9373, 174.8935],
            '2014': [-36.898, 174.9308],
            '2016': [-36.965, 174.924],
            '2018': [-36.8818, 175.0134],
            '2022': [-36.9784, 174.7817],
            '2023': [-36.969, 174.8822],
            '2024': [-36.9559, 174.8184],
            '2122': [-37.1379, 174.6979],
            '2140': [-36.9121, 174.8708],
            '2141': [-36.9311, 174.8971],
            '2142': [-36.9322, 174.9122],
            '2143': [-36.8983, 174.9069],
            '2144': [-36.8681, 174.904],
            '2145': [-36.8937, 174.9315],
            '2146': [-36.9041, 174.9392],
            '2147': [-36.8825, 174.9969],
            '2148': [-36.8804, 175.0343],
            '2149': [-36.9456, 174.965],
            '2150': [-36.9986, 174.7885],
            '2151': [-36.9422, 174.7875],
            '2153': [-36.9702, 174.7993],
            '2154': [-36.9699, 174.7856],
            '2155': [-36.9714, 174.8621],
            '2156': [-36.9797, 174.8541],
            '2157': [-36.9805, 174.8767],
            '2158': [-36.9665, 174.8251],
            '2159': [-36.9611, 174.8732],
            '2160': [-36.9774, 174.8968],
            '2240': [-37.0068, 174.875],
            '2241': [-36.992, 174.8815],
            '2242': [-37.0332, 174.8692],
            '2243': [-37.022, 174.8966],
            '2244': [-37.0616, 174.9417],
            '2245': [-37.0392, 174.9198],
            '2246': [-37.0486, 174.9282],
            '2247': [-37.1023, 174.9514],
            '2248': [-36.9927, 175.0373],
            '2340': [-37.1999, 174.9058],
            '2341': [-37.251, 174.7286],
            '2342': [-37.258, 174.9466],
            '2343': [-37.1862, 174.9912],
            '2344': [-37.1871, 174.829],
            '2345': [-37.1495, 174.7647],
            '2440': [-37.2457, 175.0215],
            '2441': [-37.3231, 175.0694],
            '2695': [-37.4521, 174.8611],
            '3040': [-38.1377, 176.2507],
            '3041': [-38.0805, 176.2124],
            '3042': [-38.1345, 176.2952],
            '3043': [-38.1592, 176.2567],
            '3044': [-38.1448, 176.2375],
            '3045': [-38.14, 176.2516],
            '3046': [-38.1294, 176.2337],
            '3047': [-38.1291, 176.2195],
            '3048': [-38.1602, 176.2355],
            '3049': [-38.0953, 176.0768],
            '3060': [-38.436, 176.3411],
            '3062': [-38.4562, 176.7041],
            '3123': [-38.0646, 177.0066],
            '3140': [-37.6934, 176.1622],
            '3141': [-37.685, 176.1682],
            '3142': [-37.7267, 176.1332],
            '3143': [-37.6739, 176.1649],
            '3144': [-37.6982, 176.1597],
            '3145': [-37.6684, 176.1405],
            '3146': [-37.6898, 176.1352],
            '3147': [-37.6959, 176.1094],
            '3148': [-37.7162, 176.1793],
            '3149': [-37.6553, 176.2004],
            '3150': [-37.6381, 176.1836],
            '3151': [-37.7006, 176.2838],
            '3152': [-37.676, 176.223],
            '3154': [-37.6326, 176.0523],
            '3158': [-37.9524, 176.9959],
            '3159': [-37.9621, 176.9819],
            '3160': [-37.9752, 176.8264],
            '3161': [-37.9642, 177.0361],
            '3162': [-38.0057, 177.2847],
            '3163': [-38.0653, 177.0034],
            '3164': [-38.1431, 177.0767],
            '3166': [-37.5528, 175.9174],
            '3167': [-38.0362, 176.7976],
            '3168': [-37.8886, 176.7586],
            '3169': [-38.0867, 176.7012],
            '3214': [-37.7708, 175.2985],
            '3240': [-37.7849, 175.276],
            '3241': [-37.7571, 175.2475],
            '3242': [-37.7881, 175.2644],
            '3243': [-37.7955, 175.2458],
            '3244': [-37.7852, 175.2802],
            '3245': [-37.8175, 175.2824],
            '3246': [-37.8224, 175.2876],
            '3247': [-37.7914, 175.2944],
            '3248': [-37.7514, 175.2799],
            '3249': [-37.738, 175.253],
            '3251': [-37.7985, 175.3157],
            '3252': [-37.7723, 175.2934],
            '3253': [-37.8017, 175.3223],
            '3254': [-37.7899, 175.3261],
            '3255': [-37.7876, 175.3166],
            '3256': [-37.729, 175.2734],
            '3257': [-37.7651, 175.2534],
            '3260': [-37.8043, 175.395],
            '3261': [-37.7974, 175.1535],
            '3262': [-37.6941, 175.19],
            '3263': [-37.7432, 175.1526],
            '3264': [-37.6696, 175.3041],
            '3265': [-37.8003, 174.87],
            '3266': [-37.8289, 174.957],
            '3310': [-37.6, 175.6334],
            '3332': [-38.6195, 176.103],
            '3340': [-37.6577, 175.5275],
            '3341': [-37.6015, 175.6281],
            '3342': [-37.5429, 175.7124],
            '3343': [-37.5523, 175.7039],
            '3351': [-38.6868, 176.0718],
            '3352': [-38.6828, 176.0709],
            '3353': [-38.9887, 175.8087],
            '3360': [-39.0266, 176.5734],
            '3380': [-37.5909, 175.6224],
            '3440': [-37.8111, 175.7725],
            '3441': [-37.7591, 175.7525],
            '3442': [-37.9782, 175.7568],
            '3443': [-38.0516, 175.7788],
            '3444': [-38.2176, 175.8717],
            '3445': [-38.3704, 175.774],
            '3450': [-37.895, 175.4719],
            '3451': [-37.8605, 175.4531],
            '3540': [-37.139, 175.542],
            '3541': [-37.2763, 175.4971],
            '3542': [-36.8358, 175.7045],
            '3543': [-36.7586, 175.4984],
            '3544': [-37.002, 175.8482],
            '3545': [-37.2378, 175.5664],
            '3546': [-37.0206, 175.8587],
            '3547': [-36.6344, 175.4767],
            '3600': [-37.3735, 175.6712],
            '3620': [-37.1974, 175.869],
            '3640': [-37.381, 175.671],
            '3641': [-37.3923, 175.8413],
            '3642': [-37.4117, 175.9424],
            '3643': [-37.2071, 175.8715],
            '3672': [-37.3715, 175.6157],
            '3740': [-37.558, 175.1589],
            '3741': [-37.4039, 175.144],
            '3742': [-37.6659, 175.1482],
            '3840': [-38.0104, 175.3237],
            '3841': [-38.0377, 175.3454],
            '3843': [-38.0639, 174.8229],
            '3872': [-38.0733, 175.4515],
            '3875': [-38.0405, 175.29],
            '3885': [-38.0142, 174.9774],
            '3895': [-37.9508, 174.9124],
            '3900': [-38.1807, 175.223],
            '3940': [-38.1864, 175.2115],
            '3941': [-38.3344, 175.1656],
            '3942': [-38.4665, 175.016],
            '3943': [-38.2521, 175.1787],
            '3944': [-38.5204, 175.3638],
            '3945': [-38.5784, 174.8403],
            '3946': [-38.8844, 175.2639],
            '3947': [-38.8418, 174.9827],
            '3948': [-39.177, 175.4022],
            '3949': [-39.046, 175.6038],
            '3970': [-38.5064, 174.971],
            '3975': [-38.2977, 175.3482],
            '3976': [-38.2536, 175.2194],
            '3986': [-38.2923, 175.1961],
            '3990': [-39.1517, 175.2283],
            '3998': [-38.6202, 175.3978],
            '4032': [-37.8926, 178.32],
            '4040': [-38.6641, 178.025],
            '4041': [-38.6751, 178.0449],
            '4042': [-38.4695, 177.8638],
            '4043': [-37.8902, 178.3191],
            '4044': [-38.7742, 177.5665],
            '4045': [-38.624, 177.8904],
            '4046': [-38.3727, 178.2971],
            '4047': [-38.1303, 178.315],
            '4048': [-38.0558, 178.3065],
            '4049': [-37.7963, 178.4107],
            '4050': [-37.6336, 178.3694],
            '4051': [-38.3576, 177.5345],
            '4052': [-38.2569, 177.548],
            '4140': [-39.4909, 176.9182],
            '4141': [-39.5357, 176.8487],
            '4142': [-39.5073, 176.8821],
            '4143': [-39.5002, 176.9031],
            '4144': [-39.4809, 176.8981],
            '4145': [-39.5264, 176.8614],
            '4146': [-39.5081, 176.8868],
            '4147': [-39.5106, 176.8696],
            '4148': [-39.5839, 176.9148],
            '4149': [-39.419, 176.8665],
            '4153': [-39.6312, 176.8314],
            '4154': [-39.6254, 176.7866],
            '4155': [-39.6284, 176.8498],
            '4156': [-39.6408, 176.8425],
            '4157': [-39.6694, 176.8783],
            '4158': [-39.6396, 176.8466],
            '4159': [-39.6378, 176.8527],
            '4160': [-39.0333, 177.419],
            '4161': [-39.6038, 176.8928],
            '4162': [-39.204, 176.8815],
            '4163': [-38.9666, 177.4102],
            '4164': [-38.8194, 177.1439],
            '4165': [-39.0425, 177.7403],
            '4166': [-39.0869, 177.9185],
            '4197': [-39.063, 177.2422],
            '4200': [-39.9973, 176.5591],
            '4202': [-39.898, 176.6275],
            '4203': [-40.0222, 176.3499],
            '4210': [-39.9289, 176.5855],
            '4240': [-39.9442, 176.5868],
            '4241': [-39.8966, 176.6287],
            '4242': [-39.9954, 176.5563],
            '4243': [-40.0282, 176.3484],
            '4244': [-39.913, 176.4185],
            '4245': [-40.3024, 176.6101],
            '4275': [-39.9644, 176.5872],
            '4277': [-39.8817, 176.7075],
            '4285': [-40.007, 176.623],
            '4288': [-39.9737, 176.402],
            '4340': [-39.0586, 174.0682],
            '4341': [-39.05, 174.1017],
            '4342': [-39.0572, 174.0741],
            '4343': [-39.0708, 174.0628],
            '4344': [-39.0628, 174.0452],
            '4345': [-39.1156, 173.9574],
            '4346': [-39.0021, 174.2361],
            '4347': [-39.1568, 174.2072],
            '4348': [-39.191, 173.8794],
            '4349': [-38.9979, 174.3907],
            '4351': [-39.0355, 174.1432],
            '4352': [-39.3393, 174.283],
            '4353': [-39.4298, 174.2994],
            '4360': [-39.0666, 174.1028],
            '4399': [-39.4309, 174.6351],
            '4440': [-40.3581, 175.6107],
            '4441': [-40.3476, 175.6277],
            '4442': [-40.3454, 175.5952],
            '4443': [-40.3622, 175.5984],
            '4444': [-40.3555, 175.6123],
            '4445': [-40.3726, 175.593],
            '4446': [-40.3632, 175.6338],
            '4448': [-40.3874, 175.6393],
            '4540': [-39.9344, 175.0532],
            '4541': [-39.9295, 175.0466],
            '4542': [-39.9096, 175.0533],
            '4543': [-39.9428, 175.0226],
            '4544': [-39.7637, 174.6343],
            '4545': [-39.756, 174.4737],
            '4547': [-40.0467, 175.2138],
            '4548': [-40.0394, 175.1756],
            '4549': [-39.8069, 174.734],
            '4640': [-39.59, 174.2837],
            '4641': [-39.5515, 174.125],
            '4642': [-39.4293, 174.1506],
            '4645': [-39.4539, 173.8585],
            '4646': [-39.4259, 175.2765],
            '4660': [-39.4176, 175.3987],
            '4675': [-39.5066, 174.2201],
            '4740': [-40.2267, 175.5654],
            '4741': [-40.0668, 175.3787],
            '4742': [-39.6773, 175.7982],
            '4744': [-40.0574, 175.7794],
            '4745': [-39.9371, 175.5685],
            '4746': [-39.8096, 175.7887],
            '4847': [-40.2902, 175.7552],
            '4848': [-40.4749, 175.2812],
            '4849': [-40.4683, 175.2382],
            '4860': [-40.5496, 175.4138],
            '4861': [-39.4759, 175.6686],
            '4862': [-40.2198, 175.4242],
            '4863': [-40.174, 175.3864],
            '4864': [-40.4745, 175.5097],
            '4865': [-40.293, 175.4249],
            '4866': [-40.383, 175.5453],
            '4867': [-40.2825, 175.6311],
            '4940': [-40.6454, 175.7031],
            '4941': [-40.4521, 175.8422],
            '4942': [-40.2098, 176.0966],
            '4943': [-40.0694, 176.2163],
            '4944': [-40.5426, 176.1906],
            '4945': [-40.3378, 175.8689],
            '4990': [-40.4787, 176.1541],
            '5016': [-41.2128, 174.8499],
            '5040': [-41.2095, 174.9015],
            '5041': [-41.1986, 174.9476],
            '5042': [-41.2148, 174.922],
            '5043': [-41.2271, 174.9053],
            '5044': [-41.1988, 174.9358],
            '5045': [-41.2253, 174.8662],
            '5046': [-41.2255, 174.8795],
            '5047': [-41.2906, 174.8985],
            '5048': [-41.2608, 174.9457],
            '5049': [-41.2725, 174.9546],
            '5050': [-41.209, 174.8783],
            '5140': [-41.124, 175.0737],
            '5141': [-41.1745, 174.9816],
            '5142': [-41.148, 175.012],
            '5143': [-41.138, 175.0342],
            '5240': [-41.1349, 174.8403],
            '5242': [-41.1086, 174.838],
            '5243': [-41.1416, 174.8654],
            '5245': [-41.1178, 174.8933],
            '5247': [-41.0933, 174.8686],
            '5249': [-41.1703, 174.8247],
            '5250': [-40.8767, 175.0642],
            '5252': [-40.8939, 174.9811],
            '5254': [-40.9165, 175.0055],
            '5255': [-40.9189, 174.9822],
            '5258': [-40.9884, 174.9515],
            '5540': [-40.6222, 175.2866],
            '5541': [-40.7124, 175.2168],
            '5542': [-40.7526, 175.1389],
            '5543': [-40.7621, 175.156],
            '5544': [-40.804, 175.1192],
            '5740': [-41.117, 175.3248],
            '5741': [-41.2191, 175.4583],
            '5742': [-41.0802, 175.4603],
            '5743': [-41.0251, 175.5276],
            '5840': [-40.9497, 175.6614],
            '5842': [-40.9581, 175.6487],
            '6140': [-41.2809, 174.7794],
            '6141': [-41.2942, 174.7762],
            '6142': [-41.2902, 174.7757],
            '6143': [-41.2825, 174.775],
            '6144': [-41.2759, 174.778],
            '6145': [-41.2798, 174.7761],
            '6146': [-41.2838, 174.7763],
            '6147': [-41.2851, 174.7368],
            '6148': [-41.2842, 174.7752],
            '6149': [-41.2942, 174.7831],
            '6150': [-41.289, 174.7618],
            '6160': [-41.2776, 174.7775],
            '6241': [-41.3194, 174.7942],
            '6242': [-41.3133, 174.7795],
            '6243': [-41.316, 174.8159],
            '6244': [-41.3331, 174.8103],
            '6440': [-41.223, 174.807],
            '6441': [-41.2464, 174.7909],
            '6442': [-41.2227, 174.8229],
            '6443': [-41.2512, 174.773],
            '7040': [-41.271, 173.2837],
            '7041': [-41.3146, 173.2328],
            '7042': [-41.2744, 173.2766],
            '7043': [-41.265, 173.2774],
            '7044': [-41.301, 173.2426],
            '7045': [-41.2832, 173.2772],
            '7046': [-41.281, 173.2699],
            '7047': [-41.269, 173.2944],
            '7048': [-41.2532, 173.0958],
            '7049': [-41.8003, 172.3257],
            '7050': [-41.3385, 173.1848],
            '7051': [-41.3765, 173.11],
            '7052': [-41.4062, 173.0428],
            '7053': [-41.8025, 172.8462],
            '7054': [-40.6764, 172.6823],
            '7055': [-41.389, 172.8237],
            '7142': [-40.8595, 172.8059],
            '7143': [-41.1127, 173.0112],
            '7144': [-41.2696, 173.0061],
            '7145': [-41.228, 173.5831],
            '7146': [-41.085, 172.9971],
            '7150': [-41.2786, 173.767],
            '7201': [-41.5456, 173.9572],
            '7240': [-41.5137, 173.9573],
            '7241': [-41.5093, 173.9353],
            '7242': [-41.5301, 173.9552],
            '7243': [-41.5077, 173.8276],
            '7244': [-41.4611, 173.9618],
            '7246': [-41.4301, 173.9632],
            '7247': [-41.6736, 174.076],
            '7248': [-41.8292, 174.1308],
            '7250': [-41.2913, 174.007],
            '7251': [-41.2669, 174.0483],
            '7260': [-42.0033, 174.0105],
            '7340': [-42.3891, 173.6637],
            '7341': [-42.8123, 173.2738],
            '7343': [-42.6555, 173.0396],
            '7345': [-42.7747, 172.8473],
            '7348': [-42.9236, 172.6428],
            '7360': [-42.5213, 172.8294],
            '7440': [-43.3035, 172.5954],
            '7441': [-43.1546, 172.7302],
            '7442': [-42.9672, 172.6851],
            '7443': [-43.2977, 172.194],
            '7444': [-43.3114, 172.3793],
            '7446': [-43.2104, 172.7539],
            '7447': [-43.0598, 172.7558],
            '7448': [-43.2867, 172.7164],
            '7500': [-43.3895, 172.0202],
            '7540': [-43.3872, 172.0163],
            '7541': [-43.4898, 172.1106],
            '7542': [-43.8053, 172.9668],
            '7543': [-43.5009, 172.2168],
            '7544': [-43.5436, 171.9775],
            '7545': [-43.7503, 172.9324],
            '7546': [-43.7703, 172.791],
            '7548': [-43.748, 172.3276],
            '7640': [-43.6405, 172.4841],
            '7641': [-43.3224, 172.6659],
            '7642': [-43.8115, 172.2516],
            '7643': [-43.5927, 172.376],
            '7644': [-43.3825, 172.6588],
            '7645': [-43.6618, 172.5484],
            '7646': [-43.4833, 171.9644],
            '7647': [-43.643, 172.4691],
            '7649': [-43.3371, 171.9272],
            '7656': [-43.7636, 172.296],
            '7657': [-43.6591, 172.1964],
            '7740': [-43.903, 171.7503],
            '7741': [-43.92, 171.7206],
            '7742': [-43.8874, 171.7427],
            '7743': [-43.7551, 172.0207],
            '7745': [-43.6332, 171.6468],
            '7746': [-43.7058, 171.402],
            '7747': [-44.0032, 171.5687],
            '7748': [-43.8208, 171.4225],
            '7777': [-43.9445, 171.9202],
            '7840': [-42.4491, 171.2108],
            '7841': [-42.402, 171.2522],
            '7842': [-42.7172, 170.9614],
            '7843': [-42.3486, 171.5407],
            '7844': [-43.862, 169.0035],
            '7845': [-42.5722, 171.483],
            '7846': [-42.2712, 171.6849],
            '7847': [-42.3351, 172.182],
            '7848': [-41.714, 171.763],
            '7851': [-42.1194, 171.8648],
            '7856': [-43.3888, 170.182],
            '7857': [-43.262, 170.3604],
            '7859': [-43.4655, 170.0172],
            '7860': [-42.8988, 170.8167],
            '7861': [-42.63, 171.1859],
            '7862': [-42.1885, 172.2204],
            '7863': [-43.1491, 170.5572],
            '7864': [-41.2514, 172.1284],
            '7865': [-41.9073, 171.4381],
            '7866': [-41.7557, 171.599],
            '7867': [-41.6068, 171.8779],
            '7940': [-44.395, 171.2532],
            '7941': [-44.3563, 171.238],
            '7942': [-44.3906, 171.2445],
            '7943': [-44.4053, 171.2344],
            '7944': [-44.258, 170.1],
            '7945': [-44.0043, 170.4772],
            '7946': [-43.7327, 170.0938],
            '7947': [-44.2601, 171.1275],
            '7948': [-44.244, 171.2773],
            '7949': [-44.0984, 170.8295],
            '7956': [-44.0912, 171.2436],
            '7957': [-44.3103, 170.9524],
            '7960': [-44.7334, 171.0476],
            '8140': [-43.5319, 172.6316],
            '8141': [-43.5286, 172.6392],
            '8142': [-43.5352, 172.6403],
            '8143': [-43.5136, 172.6377],
            '8144': [-43.5241, 172.6307],
            '8145': [-43.5404, 172.6585],
            '8146': [-43.5127, 172.622],
            '8147': [-43.5302, 172.6573],
            '8148': [-43.5177, 172.6559],
            '8149': [-43.5451, 172.6083],
            '8240': [-43.5452, 172.6365],
            '8241': [-43.5498, 172.6842],
            '8242': [-43.5579, 172.6366],
            '8243': [-43.5457, 172.6085],
            '8244': [-43.5571, 172.6189],
            '8245': [-43.5802, 172.567],
            '8246': [-43.558, 172.6542],
            '8247': [-43.5574, 172.7026],
            '8440': [-43.5298, 172.6012],
            '8441': [-43.5432, 172.5252],
            '8442': [-43.5318, 172.5723],
            '8443': [-43.5384, 172.5559],
            '8444': [-43.5167, 172.5718],
            '8445': [-43.5533, 172.4732],
            '8540': [-43.5177, 172.5884],
            '8542': [-43.4952, 172.6088],
            '8543': [-43.489, 172.5872],
            '8544': [-43.4884, 172.5388],
            '8545': [-43.489, 172.567],
            '8546': [-43.4454, 172.6324],
            '8640': [-43.507, 172.6631],
            '8641': [-43.5073, 172.7287],
            '8642': [-43.533, 172.6735],
            '8643': [-43.5178, 172.7005],
            '8840': [-43.569, 172.7593],
            '8841': [-43.603, 172.7223],
            '8842': [-43.4816, 172.706],
            '8941': [-43.6252, 172.7402],
            '8942': [-45.2397, 178.0457],
            '9040': [-45.881, 170.4796],
            '9041': [-45.855, 170.5192],
            '9042': [-45.8579, 170.4783],
            '9043': [-45.8584, 170.501],
            '9044': [-45.8944, 170.4994],
            '9045': [-45.8964, 170.4806],
            '9046': [-45.9003, 170.5041],
            '9047': [-45.9062, 170.4874],
            '9048': [-45.8394, 170.6511],
            '9049': [-45.8976, 170.5154],
            '9050': [-45.8157, 170.6218],
            '9052': [-45.9017, 170.4296],
            '9053': [-45.8758, 170.3489],
            '9054': [-45.8777, 170.5018],
            '9058': [-45.8724, 170.5036],
            '9059': [-45.8661, 170.5096],
            '9062': [-45.8566, 170.2312],
            '9067': [-45.507, 170.119],
            '9069': [-45.7457, 170.5681],
            '9240': [-46.2388, 169.7388],
            '9241': [-46.1225, 169.9577],
            '9242': [-46.1006, 169.5278],
            '9340': [-45.2562, 169.3928],
            '9341': [-45.187, 169.3169],
            '9342': [-45.037, 169.1977],
            '9343': [-44.6943, 169.1392],
            '9344': [-44.6826, 169.1886],
            '9345': [-44.6108, 169.2564],
            '9346': [-44.2315, 169.2322],
            '9347': [-44.8376, 169.4117],
            '9348': [-45.0319, 168.6622],
            '9349': [-45.0159, 168.731],
            '9350': [-44.8498, 168.3841],
            '9351': [-44.9388, 168.833],
            '9352': [-45.0939, 169.6023],
            '9353': [-45.1301, 170.0998],
            '9354': [-45.0232, 170.1467],
            '9355': [-45.0301, 170.01],
            '9356': [-46.1943, 168.866],
            '9441': [-45.5409, 169.3153],
            '9442': [-45.3238, 170.8172],
            '9443': [-45.4854, 170.7146],
            '9444': [-45.0976, 170.9701],
            '9445': [-44.8538, 170.6817],
            '9446': [-44.733, 170.4698],
            '9447': [-44.6063, 170.1929],
            '9448': [-44.4883, 169.966],
            '9500': [-45.5421, 169.2875],
            '9541': [-45.5958, 170.6701],
            '9542': [-45.9435, 169.2613],
            '9543': [-45.9129, 169.6866],
            '9544': [-45.6629, 169.4118],
            '9546': [-46.4511, 169.6583],
            '9548': [-46.2023, 169.3741],
            '9640': [-45.4152, 167.7164],
            '9641': [-46.1435, 167.9974],
            '9642': [-46.1332, 167.6892],
            '9643': [-45.5661, 167.6092],
            '9644': [-45.9702, 168.0321],
            '9645': [-45.9326, 167.9568],
            '9740': [-46.1, 168.9448],
            '9741': [-46.1428, 168.3247],
            '9742': [-45.7392, 168.4415],
            '9743': [-45.9215, 169.0145],
            '9744': [-45.9021, 168.7426],
            '9745': [-45.7249, 168.8484],
            '9746': [-45.8377, 168.5889],
            '9747': [-45.6698, 168.2389],
            '9748': [-45.3381, 168.7237],
            '9749': [-45.5095, 168.5739],
            '9750': [-45.467, 168.6838],
            '9752': [-45.8989, 168.3698],
            '9840': [-46.4109, 168.3511],
            '9841': [-46.3982, 168.3658],
            '9842': [-46.5991, 168.3436],
            '9843': [-46.3772, 168.3471],
            '9844': [-46.4276, 168.3612],
            '9845': [-46.4017, 168.3853],
            '9846': [-46.8992, 168.1292],
            '9847': [-46.3522, 168.0136],
            '9848': [-46.3132, 168.7842],
            '9849': [-46.3322, 168.8477],
        };

        var m = address.match(/([0-9]+) ([a-zA-Z\s]+)/);

        if (m && (m.length === 3)) {
            if ((m[2] === 'Australia') && (m[1] in postcodesAU)) {
                return postcodesAU[m[1]];
            } else if ((m[2] === 'New Zealand') && (m[1] in postcodesNZ)) {
                return postcodesNZ[m[1]];
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }

	getLatLng(address) {
		var successPromise = $.Deferred();
        const mapStoreState = MapStore.getState();

        let latlng = new this.googleMaps.LatLng(mapStoreState.latLng.lat(), mapStoreState.latLng.lng());
        setTimeout(function() {successPromise.resolve(latlng);}, 0);
        return successPromise;
	}

	setMapAddress(latLng) {
        try {
            if (CUSTOM_LAT_LNG_CONSTRUCTOR_NAME === latLng.constructor.name) {
                //re-create latLng object using google map library
                latLng = new this.googleMaps.LatLng(latLng.lat(), latLng.lng());
            }

            this.setLocation(latLng);
            this.map.panTo(latLng);
        } catch (e) {
            const newLocation = this._recreateLatLng(latLng);
            this.setLocation(newLocation);
            this.map.panTo(newLocation);
        }
	}

	/**
	 * Set address in the map
	 * @param {String}   address  [description]
	 * @param {Function} callback [description]
	 */
	setAddress(address, callback) {

		// very ugly hack to circumvent google maps fuckup with 2000-2030 postcodes
		// https://issuetracker.google.com/issues/75985322
		var latlng = this.checkForPostcodeFix(address);
		if (latlng) {
			callback({latitude: latlng[0], longitude: latlng[1], limit: 15});
			return;
		}

		this.geocoder.geocode(
			{
				'address' : address
			},
			$.proxy(
				function (result, status) {

					if (status !== this.googleMaps.GeocoderStatus.OK) {
						console.log('error handling');
					}

					var latLng = result[0].geometry.location;
					//Update map location
					this.setLocation(latLng);
					this.map.panTo(latLng);

					var latlng = this.parseGoogleLatLng(latLng);

					//Todo - implement based on map bounds
					latlng.limit = 15;
					//Pass formatted location back to callback
					callback(latlng);
				},
				this
			)
		);
	}

	/**
	 * @param {Object} from
	 * @param {Object} to
	 * @return {Number}
	 */
	calculateDistance(from, to) {
		return this.googleMaps.geometry.spherical.computeDistanceBetween(
			this.formatLocation(from.latitude, from.longitude),
			this.formatLocation(to.latitude, to.longitude)
		);
	}

	updateView(useCurrentLatLng = true) {
		var bounds = this.getBounds();

		if (useCurrentLatLng || !this.centerLatLng) {
			this.setCenterLatLng();
		}

		if (bounds) {
			this.fitBounds(bounds);
			this.resize();
			this.setZoom(this.currentZoomLevel);
			this.map.setCenter(this.centerLatLng);
		}
	}

	setCenterLatLng() {

		var centerGetters = this.map.getCenter();
		this.centerLatLng = {
			lat: centerGetters.lat(),
			lng: centerGetters.lng()
		};
	}
}

export default Map;
